import { useAnalytics, useUser } from "@src/hooks";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function PageViewTracker() {
  const location = useLocation();
  const [user] = useUser();
  
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    const trackPageView = () => {
      const pageProperties = {
        page: location.pathname,
        url: window.location.href,
        search: location.search || undefined,
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      };
      if (user) {
        trackEvent('Page Viewed', pageProperties);
      }
    };

    // Track page view on route change
    trackPageView();
  }, [location, trackEvent, user]);

  return null;
}

export default PageViewTracker;